function initStickyBanner() {
  const body = document.body;
  const variant = body.getAttribute("data-sticky-cta");

  // Limpiar listeners previos (por seguridad)
  window.removeEventListener("scroll", checkVisibility);
  window.removeEventListener("resize", checkVisibility);

  // Ocultar banners antes de reiniciar
  const stickyBanner = document.getElementById("sticky-banner");
  if (stickyBanner) stickyBanner.style.display = "none";

  // Si no existe o no es un valor permitido, no mostrar ningún banner
  if (!variant || variant !== "true") return;

  const ctaButton = document.querySelector(".btn.btn-cta-primary");
  const spanPrice = document.querySelector(
    "fieldset.js.product-form__input.product-form__input--swatch"
  );
  const stickyBtn = document.getElementById("sticky-banner-btn");
  const stickyBtnMobile = document.getElementById("sticky-banner-btn-mobile");

  if (!ctaButton) return;
  if (!spanPrice) return;

  function checkVisibility() {
    const rect = ctaButton.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

    const miniCartActive =
      document.querySelector(".mini-cart.mini-cart--active") !== null;

    // Ocultar el banner antes de decidir mostrarlo
    if (stickyBanner) stickyBanner.style.display = "none";

    // Si el botón está visible o el minicart activo → no mostrar ninguno
    if (isVisible || miniCartActive) {
      // Ajustar iframe bottom cuando no se muestra el banner
      const iframe = document.getElementById("chat-input");
      const chatButton = document.getElementById("chat-button");
      if (iframe) {
        iframe.style.bottom = "3px";
      }
      if (chatButton) {
        chatButton.style.bottom = "3px";
      }
      return;
    }

    // Mostrar solo el banner correspondiente a la variante activa
    if (variant === "true" && stickyBanner) {
      stickyBanner.style.display = "flex";
      // Ajustar iframe bottom cuando se muestra el banner
      const iframe = document.getElementById("chat-input");
      const chatButton = document.getElementById("chat-button");
      if (iframe) {
        iframe.style.bottom = "125px";
      }
      if (chatButton) {
        chatButton.style.bottom = "130px";
      }
    } else {
      // Ajustar iframe bottom cuando no se muestra el banner
      const iframe = document.getElementById("chat-input");
      const chatButton = document.getElementById("chat-button");
      if (iframe) {
        iframe.style.bottom = "3px";
      }
      if (chatButton) {
        chatButton.style.bottom = "3px";
      }
    }
  }

  // Asignar listeners
  if (variant === "true") {
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);
    checkVisibility(); // Ejecutar de inmediato
  }

  // Botones
  if (stickyBtn)
    stickyBtn.addEventListener("click", () =>
      spanPrice.scrollIntoView({ behavior: "smooth", block: "center" })
    );
  if (stickyBtnMobile)
    stickyBtnMobile.addEventListener("click", () =>
      spanPrice.scrollIntoView({ behavior: "smooth", block: "center" })
    );
}

initStickyBanner();

// --- Escuchar cambios en el data-sticky-cta dinámicamente ---
const observerBody = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (
      mutation.type === "attributes" &&
      mutation.attributeName === "data-sticky-cta"
    ) {
      initStickyBanner(); // reiniciar la lógica si cambia el atributo
    }
  }
});

observerBody.observe(document.body, {
  attributes: true,
  attributeFilter: ["data-sticky-cta"],
});

// --- Sticky Banner Image Sync (solo aplica a variant-b) ---
function updateStickyBannerImage() {
  const activeSlide = document.querySelector(
    ".product-media-slider__slide.swiper-slide:not(.hidden)[aria-label]"
  );
  if (activeSlide) {
    const img = activeSlide.querySelector("img");
    const stickyImg = document.querySelector(".sticky-banner__img");
    if (img && stickyImg) {
      stickyImg.src = img.src;
      stickyImg.alt = img.alt || "";
    }
  }
}

function observeSlideChanges() {
  const slider = document.querySelector(".product-media-slider");
  if (!slider) return;

  const observer = new MutationObserver(() => {
    updateStickyBannerImage();
  });

  observer.observe(slider, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class", "aria-label"],
  });
}

updateStickyBannerImage();
observeSlideChanges();
